import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {SocialShareButtons} from '@communityshare/ui-shared';
import useIsProjectShareable from '@/features/share-project/hooks/useIsProjectShareable';
import useProjectImage from '@/features/share-project/hooks/useProjectImage';
import hasBeenShared from '@/features/share-project/utils/hasBeenShared';
import useProjectShareActions from '@/features/share-project/hooks/useProjectShareActions';

ProjectSocialShare.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.number,
    data: PropTypes.shape({
      title: PropTypes.string,
      published: PropTypes.bool
    })
  }).isRequired
};

// Only shown for shareable projects that have been shared already, which is
// when the share image has been saved (the share dialog saves a default one).
export default function ProjectSocialShare(props) {
  const {project} = props;
  const {t} = useTranslation();
  const isShareable = useIsProjectShareable(project);
  const projectImage = useProjectImage(project.id);
  const actions = useProjectShareActions(project);

  if (!hasBeenShared(isShareable, projectImage.image)) {
    return null;
  }

  return (
    <SocialShareButtons
      {...actions}
      copiedLinkLabel={t('controls.Copied')}
      copyLinkLabel={t('controls.Copy link')}
    />
  );
}
